import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'maskTelephone',
    standalone: false
})
export class TelephoneMaskPipe implements PipeTransform {
    transform(value: string, mask: string = '00 00 00 00 00'): string {
        if (!value) return '';
        const cleanedValue = value.replace(/\D/g, ''); // Supprime tout sauf les chiffres
        let formattedValue = '';
        let index = 0;

        for (const char of mask) {
            if (char === '0') {
                if (index < cleanedValue.length) {
                    formattedValue += cleanedValue[index++];
                } else {
                    break;
                }
            } else {
                formattedValue += char;
            }
        }

        return formattedValue;
    }
}
